<template>
    <div>

        <validation-observer ref="observer" v-slot="{ passes, invalid }">
            <b-modal title="Confirm Weight" id="confirm-order-modal" ok-title="Continue"
                     v-model="modalShow"
                     :ok-disabled="invalid"
                     :busy="working"
                     @ok="finalConfirm">
                <h5>Weight's have changed!! Please double check your weight before you continue.</h5>
            </b-modal>
        </validation-observer>
        <validation-observer ref="observer" v-slot="{ passes, invalid }">
            <b-modal title="Create New Package" id="confirm-order-modal" ok-title="Create Package"
                     v-model="modalNewPackageShow"
                     :ok-disabled="invalid"
                     :busy="working"
                     @ok="handleOKAddPackage">
                <h5>Please Confirm order details:</h5>

                <b-form>

                    <validation-provider
                            name="Tracking Number"
                            :rules="{ required: true }"
                            immediate
                            v-slot="validationContext"
                    >
                        <b-form-group
                                id="input-group-tracking"
                                label="Tracking Number:"
                                label-for="input-tracking-number"
                        >
                            <b-form-input v-model="trackingNumber.tracking_number" type="text" id="input-tracking-number"
                                          :state="getValidationState(validationContext)" :disabled="true"
                            ></b-form-input>
                        </b-form-group>
                    </validation-provider>
                    <validation-provider
                            name="Shipping Method"
                            :rules="{ required: true }"
                            immediate
                            v-slot="validationContext"
                    >
                        <b-form-group
                                id="input-group-shipping-2"
                                label="Shipping Method:"
                                label-for="input-shipping-method"
                        >
                            <b-form-select v-model="shippingSelected" :options="shippingOptions"
                                           id="input-shipping-method-2"
                                           :state="getValidationState(validationContext)"
                            ></b-form-select>
                        </b-form-group>
                    </validation-provider>
                </b-form>
            </b-modal>
        </validation-observer>
        <LoadingSpinner :busy="loading"></LoadingSpinner>
        <b-card v-if="order && !loading">
            <template v-slot:header>
                <OrderCardHeader :order="order"></OrderCardHeader>
            </template>
            <b-row>
                <b-col>
                    <b-card bg-variant="danger" text-variant="white" class="text-center" v-if="kitOld">
                        <h2 class="text-center"><i class="fa-solid fa-exclamation-triangle fa-fw"></i> Order has been
                            Appraised.</h2>
                    </b-card>
                    <b-card bg-variant="danger" text-variant="white" class="text-center" v-else-if="alreadyScanned">
                        <h2 class="text-center"><i class="fa-solid fa-exclamation-triangle fa-fw"></i> Package Already
                            Received.</h2>
                    </b-card>

                    <b-card :bg-variant="alertBgColor" text-variant="white" class="text-center" v-else>
                        <h2 class="text-center"><i class="fa-solid fa-box-circle-check fa-fw"></i> Package Received: {{
                            packagesReceivedCount }} of {{ order.packages_expected }}</h2>
                    </b-card>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="3">
                    <b-card header="Shipment Details" header-bg-variant="secondary" class="header-sm">
                        <b-badge v-if="trackingNumber.shipper.name === 'FedEx Standard Overnight'" pill
                                 variant="primary">{{ trackingNumber.shipper.name }}
                        </b-badge>
                        <div class="data" v-else>{{ trackingNumber.shipper.name }}</div>

                        <div class="label text-black-50"><i class="fa-light fa-shipping-timed fa-fw"></i> Expected Receive
                            Date
                        </div>
                        <div class="data">{{ trackingNumber.expected_delivery_at }}</div>

                        <div class="label text-black-50"><i class="fa-light fa-barcode-scan fa-fw"></i> Tracking Number</div>
                        <div class="data">{{ trackingNumber.tracking_number }}</div>

                        <div class="label text-black-50"><i class="fa-light fa-boxes fa-fw"></i> Number of Packages</div>
                        <div class="data">{{ order.packages_expected }}</div>

                    </b-card>
                </b-col>
                <b-col>
                    <b-card no-body header="Package Weight" header-bg-variant="secondary" class="header-sm">
                        <div class="d-flex align-items-center p-2">
                            <!--                            <i class="fa-light fa-weight fa-fw fa-2x text-black-50"></i>-->
                            <div class="flex-grow-1 d-flex align-items-center ml-1">
                                <h3 class="mb-0 mr-1" :class="weightClass()">
                                    <!--                                <template v-if="scaleSaved && scaleStable">{{ order.packages[0].total_dwt }}</template>-->
                                    <!--                                    <template>{{ weightDisplay() }}</template>-->
                                    <ScaleWeight v-on:scale-stable="scaleStable = $event"
                                                 v-on:scale-weight="scaleWeight = $event"
                                                 ref="scale"></ScaleWeight>

                                </h3>
                            </div>
                            <div class="text-right">
                                <i class="fa-solid fa-spinner-third fa-spin fa-fw fa-lg text-info"
                                   v-if="scaleSaving && scaleSaved !== true"></i>
                                <i class="fa-solid fa-check fa-fw fa-lg text-success"
                                   v-if="scaleStable && scaleWeight > 0 && scaleSaved"></i>
                            </div>
                            <template v-if="scaleStable && scaleWeight > 0 && scaleSaved">
                                {{ this.package.total_dwt.toFixed(1) }}
                                <b-button variant="link" class="p-0" @click="savePackage" :disabled="!_canEdit"><i
                                        class="fa-solid fa-redo-alt fa-fw fa-lg text-primary"></i></b-button>
                            </template>
                        </div>
                    </b-card>
                    <b-card header="Order Details" header-bg-variant="secondary" class="header-sm">
                        <b-row>
                            <b-col cols="6">
                                <div class="label text-black-50"><i class="fa-light fa-home fa-fw"></i> Address</div>
                                <div class="data">
                                    <div>{{ order.address.address1 }}</div>
                                    <div v-if="order.address.address2">{{ order.address.address2 }}</div>
                                    <div>{{ order.address.city }}, {{ order.address.state }} {{ order.address.zip }}
                                    </div>
                                </div>
                            </b-col>
                            <b-col cols="6">
                                <div class="label text-black-50"><i class="fa-light fa-at fa-fw"></i> Email</div>
                                <div class="data">{{ order.email }}</div>

                                <div class="label text-black-50"><i class="fa-light fa-phone fa-fw"></i> Phone</div>
                                <div class="data">{{ order.phone }}</div>
                            </b-col>
                        </b-row>

                    </b-card>

                    <!--<b-card header="Order Flags" header-bg-variant="secondary" class="header-sm">-->
                        <!--<b-badge v-for="flag in order.flags" v-bind:key="flag.id" pill variant="primary">{{-->
                            <!--flag.flag_type.name }}-->
                        <!--</b-badge>-->

                    <!--</b-card>-->
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-card header="Scan Results" header-bg-variant="secondary">
                        <b-row>
                            <b-col cols="3" class="text-center">
                                <div class="data-number">{{ order.packages_expected }}</div>
                                <div class="data-label">Packages Expected</div>
                            </b-col>

                            <b-col cols="3" class="text-center">
                                <div :class="['data-number', packagesReceivedStyle]">{{ packagesReceivedCount }}</div>
                                <div class="data-label">Packages Received</div>
                            </b-col>

                            <b-col cols="3" class="text-center">
                                <div :class="['data-number', packagesOutstandingStyle]">{{ packagesOutstandingCount }}
                                </div>
                                <div class="data-label">Packages Outstanding</div>
                            </b-col>

                            <b-col cols="3" class="text-center">
                                <div class="data-number">{{ totalPackagesWeight.toFixed(2) }}</div>
                                <div class="data-label">Total Package Weight</div>
                            </b-col>
                        </b-row>

                    </b-card>
                </b-col>
            </b-row>

            <b-row>
                <b-col class="text-right">
                    <template v-if="kitOld">
                        <b-button variant="warning" class="mx-1" @click="createNewOrder" :disabled="working || loadingAltOrders">
                            <i v-if="loadingAltOrders" class="fa-solid fa-spin fa-spinner"></i>
                            <i v-else class="fa-solid fa-cart-plus fa-fw"></i>
                            <span v-if="loadingAltOrders"></span>
                            <span v-else-if="altOrder">Assign Package To Open Order</span>
                            <span v-else>Create New Order and Assign Package</span>
                        </b-button>
                    </template>
                    <template v-else-if="alreadyScanned">
                        <b-button variant="secondary" class="mx-1" :to="'/kit/view/' + order.id" replace :disabled="working"><i
                                class="fa-solid fa-box-open fa-fw"></i> View Order
                        </b-button>
                        <b-button variant="primary" class="mx-1" @click="addPackageModal"  replace :disabled="working"><i
                                class="fa-solid fa-boxes fa-fw"></i> Add Package to Existing Order
                        </b-button>
                        <b-button variant="warning" class="mx-1" @click="createNewOrder" :disabled="working || loadingAltOrders">
                            <i v-if="loadingAltOrders" class="fa-solid fa-spin fa-spinner"></i>
                            <i v-else class="fa-solid fa-cart-plus fa-fw"></i>
                            <span v-if="loadingAltOrders"></span>
                            <span v-else-if="altOrder">Assign Package To Open Order</span>
                            <span v-else>Create New Order and Assign Package</span>
                        </b-button>
                        <b-button variant="danger" class="mx-1" to="/intake/" :disabled="working"><i
                                class="fa-solid fa-check fa-fw"></i>
                            Cancel
                        </b-button>
                    </template>
                    <template v-else>
                        <b-button variant="secondary" class="mx-1" :to="'/kit/view/' + order.id"  replace :disabled="working"><i
                                class="fa-solid fa-box-open fa-fw"></i> View Order
                        </b-button>
                        <b-button variant="primary" @click="confirmFinish()" exact replace :disabled="working || !scaleSaved"><i class="fa-solid fa-check fa-fw"></i>
                            Done
                        </b-button>
                    </template>
                </b-col>
            </b-row>
        </b-card>
        <NotesPopup :order_id="order_id" :customer_id="customer_id" style="z-index: 1000">

        </NotesPopup>
    </div>
</template>

<script>
    import _ from 'lodash';
    import {each} from 'lodash';
    import LoadingSpinner from '../../components/LoadingSpinner';
    import OrderCardHeader from '@/components/OrderCardHeader';
    import NotesPopup from '../../components/NotesPopup';
    import ScaleWeight from '@/components/ScaleWeight';

    export default {
        name: 'intake-view',
        components: {
            NotesPopup,
            LoadingSpinner,
            OrderCardHeader,
            ScaleWeight,
        },
        data() {
            return {
                loading: false,
                working: false,
                scaleStable: false,
                scaleWeight: null,
                scaleSaving: false,
                scaleSaved: false,
                order: null,
                altOrder: null,
                loadingAltOrders: true,
                trackingNumber: null,
                package: null,
                modalShow: null,
                modalNewPackageShow: null,
                alreadyScanned: false,
                shippingSelected: null,
                shippingOptions: [],
            };
        },
        created() {
            this.setData();

            let vm = this;
            this.$http.get('/shippers')
                .then(response => {
                    each(response.data.data, item => {
                        this.shippingOptions.push({value: item.id, text: item.carrier + ' - ' + item.name});
                    });
                });

        },
        mounted() {
            this.$barcodeScanner.init((rawBarcode) => {
                this.$barcodeScanner.parseBarcode(rawBarcode, barcode => {
                    this.$router.push({path: '/intake/view/' + encodeURIComponent(barcode)});
                });
            });
        },
        beforeDestroy() {
            let vm = this;

            vm.$scale.disconnect().finally(() => {
                //vm.$qz.disconnect();
            });

            this.$barcodeScanner.destroy();

            this.$store.commit('setActiveOrder', null);
        },
        computed: {
            packagesReceivedCount() {
                return this.order.packages_received;
            },
            packagesReceivedStyle() {
                if (this.packagesOutstandingCount === 0) {
                    return 'text-success';
                } else {
                    return 'text-info';
                }
            },
            packagesOutstandingCount() {
                return (this.order.packages_expected - this.order.packages_received) < 0 ? 0 : this.order.packages_expected - this.order.packages_received;
            },
            packagesOutstandingStyle() {
                if (this.packagesOutstandingCount === 0) {
                    return 'text-success';
                } else {
                    return 'text-danger';
                }
            },
            alertBgColor() {
                return this.package != null ? 'success' : 'warning';
            },
            totalPackagesWeight() {
                return _.sumBy(this.order.packages, 'total_dwt');
            },
            kitReceived() {
                return this.order.received_at;
            },
            kitOld(){
                return this.order.status.id > 6;
            },
            order_id(){
                return this.order ? this.order.id : null;
            },
            customer_id(){
                return this.order ? this.order.customer_id : null;
            },
            _canEdit() {
                return !(this.order.status_id === 8
                    || this.order.status_id === 9
                    || this.order.status_id === 10
                    || this.order.status_id === 11
                    || this.order.status_id === 12
                    || this.order.status_id === 13
                    || this.order.status_id === 14
                    || this.order.status_id === 15);
            },
        },
        methods: {
            getValidationState({dirty, validated, valid = null}) {
                return dirty || validated ? valid : null;
            },
            finalConfirm(){
                this.$router.push('/intake');
            },
            confirmFinish(){
                if(!this.scaleStable || !this.package || this.scaleWeight != this.package.total_dwt){
                    this.modalShow = true;
                }
                else{
                    this.finalConfirm();
                }
            },
            loadAlternativeOrders() {
                this.loadingAltOrders = true;
                this.$http.get('/orders/' + this.order.id + '?include=customer.orders,customer.orders')
                    .then(response => {
                        this.altOrder = null;
                        let orders = response.data.data.customer.orders.data;
                        for (let i = 0; i < orders.length; i++ ){
                            let target = orders[i];
                            if(target.status_id <= 6 && !target.has_Request_expired && target.brand.id == this.order.brand.id && target.status_id != 0) {
                                this.altOrder = target;
                            }
                        }
                        if (this.altOrder && this.altOrder.id == this.order.id) {
                            this.altOrder = null;
                        }

                        this.loadingAltOrders = false;
                    });
            },
            addPackageModal(){
                this.modalNewPackageShow = true;
            },
            handleOKAddPackage(bvModalEvt) {
                bvModalEvt.preventDefault();
                this.addTrackingToOrder();
            },
            addTrackingToOrder(){
                //this.showTable = false;
                this.working = true;
                this.$http.post('/orders/' + this.order.id + '/trackingnumbers', {
                    order_id: this.order.id,
                    shipper_id: this.shippingSelected,
                    tracking_number: this.trackingNumber.tracking_number,
                    tracking_number_type: this.trackingNumber.tracking_number_type,
                    status: 'delivered',
                })
                    .then(response => {
                        console.log(response);
                        this.$router.push({
                            path: '/intake/view/' + response.data.data.tracking_number
                        })
                            .catch(err => {
                                console.log(err);
                                //the page is refusing to refresh at this point, so I take matters into my own hands
                            });
                        //TODO moved outside error because of a rare circumstance where the order does change but data is not reloaded.
                        //TODO, this is a bad fix, -- default behavior is to nagivate to the same page.
                        this.$router.go();
                    });

            },
            setData() {
                this.loading = true;
                this.working = true;
                this.scaleStable = false;
                this.scaleWeight = null;
                this.scaleSaving = false;
                this.scaleSaved = false;
                this.order = null;
                this.trackingNumber = null;
                this.package = null;
                this.$http.get('/tracking/' + this.$route.params.id + '/order')
                    .then(response => {
                        let data = response.data;
                        this.order = {
                            id: data.order.id,
                            customer: data.order.customer,
                            customer_id: data.order.customer.id,
                            status_id: data.order.status_id,
                            status: data.order.status,
                            brand_id: data.order.brand_id,
                            full_name: data.order.customer.full_name,
                            address: {
                                address1: data.order.customer.address.address1,
                                address2: data.order.customer.address.address2,
                                city: data.order.customer.address.city,
                                state: data.order.customer.address.state,
                                zip: data.order.customer.address.zip
                            },
                            email: data.order.customer.email,
                            phone: data.order.customer.phone,
                            received_at: data.order.received_at,
                            flags: data.order.flags,
                            notes: data.order.notes,
                            packages: data.order.packages,
                            packages_expected: data.packages_expected,
                            packages_received: data.packages_received,
                            brand: data.order.brand,
                        };
                        //if (this.order.status_id > 6) {
                            this.loadAlternativeOrders();
                        //}
                        this.trackingNumber = data.tracking_number;
                        this.package = data.tracking_number.package;
                        this.$store.commit('setActiveOrder', data.order);
                        if(this.package){
                            this.alreadyScanned = true;
                        }
                        if(this.order.packages_expected != this.order.packages_received){
                            this.order.received_at = null; //hide error message, new package was generated most likely!!
                        }
                        this.loading = false;
                        this.working = false;

                        if (this.package && this.package.total_dwt) {
                            this.scaleSaved = true;
                        } else {
                            // Reset value to trigger watch function for a new scan
                            this.scaleStable = false;
                        }
                        this.$store.commit('setActiveOrder', this.order);
                    })
                    .catch((error) => {
                        if (error.response && error.response.status === 404) {
                            this.$router.replace({ path: '/intake/not-found/' + this.$route.params.id });
                        }
                    });
            },
            // weightDisplay() {
            //     if (!this.$qz.connected) {
            //         return 'ERR';
            //     }
            //
            //     return this.scaleWeight.toFixed(1);
            // },
            weightClass() {
                return [
                    {'text-danger': this.scaleWeight === 0 && !this.scaleSaved},
                    {'text-warning': !this.scaleStable},
                    {'text-success': this.scaleStable && this.scaleWeight > 0},
                ];
            },
            savePackage(add_new = false) {
                this.working = true;
                this.scaleSaved = false;
                this.scaleSaving = true;

                let payload = {
                    id: this.package ? this.package.id : null,
                    order_id: this.order.id,
                    tracking_number_id: this.trackingNumber.id,
                    total_dwt: this.scaleWeight,
                    intake_total_dwt: this.scaleWeight,
                };

                if (add_new === true) {
                    payload.id = null;
                    payload.tracking_number_id = null;
                }

                this.$http.post('/orders/' + this.order.id + '/packages', payload)
                    .then(response => {
                        this.package = response.data.data.package;
                        this.scaleSaved = true;
                        this.scaleSaving = false;
                        this.order.packages_received = response.data.data.packages_received;
                        let existing_package = _.find(this.order.packages, ['id', this.package.id]);
                        if (existing_package) {
                            existing_package.total_dwt = this.package.total_dwt;
                            existing_package.intake_total_dwt = this.scaleWeight;
                        } else {
                            this.order.packages.push(this.package);
                        }

                        // Moved logic to API endpoint for Create Packages to create a single call
                        // if (this.order.packages_received >= this.order.packages_expected) {
                        //     this.$http.post('/orders/' + this.order.id + '/receive');
                        // }

                        this.working = false;
                        this.alreadyScanned = false;
                    });
            },
            createNewOrder() {
                this.alreadyScanned = false; //this is to fix a stupid bug, TODO, figure out why this is retained.
                this.loading = true;
                let payload = {
                    brand_id: this.order.brand_id,
                    payment_method: 'company-check'
                };
                let addTrackingNumFunc = () => {

                    this.$http.post('/orders/' + this.altOrder.id + '/trackingnumbers', {
                        order_id: this.altOrder.id,
                        shipper_id: this.trackingNumber.shipper_id,
                        tracking_number: this.trackingNumber.tracking_number,
                        tracking_number_type: this.trackingNumber.tracking_number_type,
                        status: 'delivered',
                    })
                        .then(response => {
                            console.log(response);
                            this.setData();
                        });
                };
                if (this.altOrder) {
                    addTrackingNumFunc();
                } else {
                    this.$http.post('/customers/' + this.order.customer_id + '/orders', payload)
                        .then(response => {
                            console.log(response);
                            this.altOrder = response.data.data;
                            addTrackingNumFunc();
                        });
                }
            }
        },
        watch: {
            scaleStable(newVal) {
                if (newVal === true && this.order && this.scaleWeight > 0 && !this.scaleSaved && _.get(this.package, 'total_dwt') !== this.scaleWeight && !this.scaleSaving && !this.kitOld) {
                    this.savePackage();
                }
            },
            '$route': 'setData'
        }
    };
</script>

<style scoped>

</style>
